import { Avatar, Card, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getCurrentSitter } from '../lib/api-client.ts';
import { Link } from 'react-router-dom';

export const SettingPage = () => {
  const { data: sitter } = useQuery({ queryKey: ['self'], queryFn: getCurrentSitter });

  return (
    <>
      <Typography.Title level={5} style={{ margin: 16 }}>
        シッター情報
      </Typography.Title>
      <Link to="/settings/profile">
        <Card style={{ margin: 16 }} loading={!sitter} hoverable>
          {sitter && (
            <Card.Meta
              avatar={<Avatar src={sitter.avatar.url} size={56} />}
              title={sitter.name}
              description={sitter.university}
            />
          )}
        </Card>
      </Link>
    </>
  );
};
